"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  A telemetry processor that handles Azure specific variables.
 */
function azureRoleEnvironmentTelemetryProcessor(envelope, context) {
    if (process.env.WEBSITE_SITE_NAME) {
        envelope.tags[context.keys.cloudRole] = process.env.WEBSITE_SITE_NAME;
    }
}
exports.azureRoleEnvironmentTelemetryProcessor = azureRoleEnvironmentTelemetryProcessor;
//# sourceMappingURL=AzureRoleEnvironmentTelemetryInitializer.js.map